<template>
    <b-col col lg="4" md="6" sm="12" class="page-element">
		<h1 class="text-center">Logowanie</h1>
		<alert-loading v-if="loading"></alert-loading>
		<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>
		<div v-if="!loading">
			<div class="login__field">
				<label for="login_email" class="control-label">E-mail</label>
				<input id="login_email" v-model="credentials.email" type="text" class="form-control" />
				<span></span>
			</div>
			<div class="login__field">
				<label for="login_password" class="control-label">Hasło</label>
				<input id="login_password" v-model="credentials.password" type="password" class="form-control" />
				<span></span>
			</div>
			<div class="login__field">
				<label for="login_company" class="control-label">Firma</label>
				<dropdown-search id="login_company" :elements="getSaaSCompanies" emptyValue="Wybierz firmę" v-model="credentials.saasCompany" valueField="@id" nameField="name"/>
			</div>

			<div class="login__field">
				<my-button text="Logowanie" icon="tick" :action="submit" />
			</div>
		</div>
    </b-col>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  export default {
	 data() {
      return {
        credentials: {
			email: '',
			password: '',
			saasCompany: ''
        }
      }
	},
	methods: {
	   submit: function(){
		   const credentials = {
					email: this.credentials.email,
					password: this.credentials.password,
					saasCompany: this.credentials.saasCompany
		   }
		   this.$store.dispatch('security/login/sendAuthRequest', credentials)
	   }
	},
	computed: {
		...mapGetters({
				getSaaSCompanies: 'security/login/getSaaSCompanies',
				loading: 'security/login/loading',
				error: 'security/login/error'
    	})
		},
    created () {
      this.$store.dispatch('security/login/loadSaaSCompanies')
    }
  }
</script>


// WEBPACK FOOTER //
// login.vue?7498cd50